import * as Sentry from "@sentry/react";
import React from "react";
import { Provider } from "react-redux";

import MapPage from "./pages/MapPage";
import configureStore from "./store";

const store = configureStore({});
const MapPageApp = () => (
  <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
    <Provider store={store}>
      <MapPage />
    </Provider>
  </Sentry.ErrorBoundary>
);

export default MapPageApp;
